import React from 'react';
import { Modal, Button, Icon } from '../ui';
import { useTranslation } from '../context/TranslationContext';
import styles from './OnboardingModal.module.css';

const STORAGE_KEY = 'mizan.onboarding.seen.v1';

export const hasSeenOnboarding = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return true;
  }
};

export const markOnboardingSeen = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch (e) {
    // ignore
  }
};

const OnboardingModal = ({ show, onClose }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    markOnboardingSeen();
    onClose();
  };

  const titleNode = (
    <span className={styles.titleRow}>
      <Icon name="fa-scale-balanced" />
      {t('onboardingTitle')}
    </span>
  );

  const footerNode = (
    <Button variant="primary" onClick={handleClose}>
      {t('onboardingDismiss')}
    </Button>
  );

  return (
    <Modal open={show} onClose={handleClose} title={titleNode} footer={footerNode} size="lg">
      <p className={styles.lead}>{t('onboardingIntro')}</p>
      <div className={styles.row}>
        <div className={styles.col}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <Icon name="fa-receipt" />
            </div>
            <h6 className={styles.featureTitle}>{t('moduleReceiptsTitle')}</h6>
            <p className={styles.featureDesc}>{t('onboardingReceiptsDesc')}</p>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.featureCard}>
            <div className={`${styles.featureIcon} ${styles.featureIconSuccess}`}>
              <Icon name="fa-credit-card" />
            </div>
            <h6 className={styles.featureTitle}>{t('moduleBudgetTitle')}</h6>
            <p className={styles.featureDesc}>{t('onboardingBudgetDesc')}</p>
          </div>
        </div>
      </div>
      <p className={styles.closingNote}>{t('onboardingClosingNote')}</p>
    </Modal>
  );
};

export default OnboardingModal;
